import React, {Component} from "react"
import './errorMessage.css'

export class ErrorMessage extends Component {
    render() {
        return <div id="errorPage"><i className="fa fa-exclamation-circle"></i><h1> { this.props.message ? <span > {this.props.message} </span> : <span>Error</span> }</h1></div>
    }
}